function resolveApiBase() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.hostname) {
    const { protocol, hostname } = window.location;
    // Dominio público Cloudflare Tunnel (casasm.org)
    if (
      hostname === "casasm.org" ||
      hostname === "www.casasm.org" ||
      hostname === "app.casasm.org" ||
      hostname.endsWith(".casasm.org")
    ) {
      return "https://api.casasm.org";
    }
    // Dominio legacy romdevs.com
    if (
      hostname === "romdevs.com" ||
      hostname === "www.romdevs.com" ||
      hostname === "app.romdevs.com" ||
      hostname.endsWith(".romdevs.com")
    ) {
      return "https://api.romdevs.com";
    }
    // LAN: preferir API pública (evita firewall/puerto 5000 en TVs)
    if (/^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(hostname)) {
      return "https://api.casasm.org";
    }
    // localhost dev
    return `${protocol}//${hostname}:5000`;
  }
  return "http://127.0.0.1:5000";
}

function connectionError(url, err) {
  const hint =
    url.includes("api.casasm.org") ||
    url.includes("casasm.org") ||
    url.includes("api.romdevs.com") ||
    url.includes("romdevs.com")
      ? "Comprueba internet/DNS en el TV y que api.casasm.org responda."
      : "¿Flask escuchando en 0.0.0.0:5000 y firewall LAN abierto?";
  const detail = err?.message ? ` (${err.message})` : "";
  return `No se pudo conectar con la API (${url}). ${hint}${detail}`;
}

export function getApiBase() {
  return resolveApiBase();
}

export async function api(path, { method = "GET", body, token, profileId } = {}) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body) headers["Content-Type"] = "application/json";

  let resolvedProfileId = profileId;
  if (resolvedProfileId == null && typeof window !== "undefined") {
    try {
      const raw = localStorage.getItem("cs_profile");
      if (raw) resolvedProfileId = JSON.parse(raw)?.id;
    } catch {
      /* ignore */
    }
  }
  if (resolvedProfileId) headers["X-Profile-Id"] = String(resolvedProfileId);

  const url = `${resolveApiBase()}${path}`;
  let response;
  try {
    response = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (err) {
    throw new Error(connectionError(url, err));
  }

  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { error: text };
  }

  if (!response.ok) {
    let message = `Error HTTP ${response.status}`;
    if (data && typeof data === "object" && data.error) {
      message = data.error;
    } else if (typeof text === "string" && text.trim().startsWith("<!")) {
      message = `Error del servidor (${response.status}). Revisa la terminal de Flask.`;
    } else if (typeof text === "string" && text.trim()) {
      message = text.slice(0, 200);
    }
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

/** Subida multipart (sin Content-Type JSON). */
export async function apiUpload(path, { file, token, profileId, fieldName = "file", fields = {} } = {}) {
  if (!file) throw new Error("Archivo requerido");

  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  let resolvedProfileId = profileId;
  if (resolvedProfileId == null && typeof window !== "undefined") {
    try {
      const raw = localStorage.getItem("cs_profile");
      if (raw) resolvedProfileId = JSON.parse(raw)?.id;
    } catch {
      /* ignore */
    }
  }
  if (resolvedProfileId) headers["X-Profile-Id"] = String(resolvedProfileId);

  const form = new FormData();
  form.append(fieldName, file);
  Object.entries(fields).forEach(([key, value]) => {
    if (value != null && value !== "") form.append(key, String(value));
  });

  const url = `${resolveApiBase()}${path}`;
  let response;
  try {
    response = await fetch(url, { method: "POST", headers, body: form });
  } catch (err) {
    throw new Error(connectionError(url, err));
  }

  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { error: text };
  }

  if (!response.ok) {
    const message =
      (data && typeof data === "object" && data.error) ||
      (typeof text === "string" && text.trim()) ||
      `Error HTTP ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
